import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Alert } from '../../components';
import css from './ExternalReviewForm.css';

export default ({ error, errorMessage }) => (
    <Alert
        header={`ExternalReviewForm.errorHeading-${error}`}
        description={
            errorMessage ? (
                <div>
                    <p>
                        <FormattedMessage id={`ExternalReviewForm.errorDesc-${error}`} />
                    </p>
                    <p>{errorMessage}</p>
                </div>
            ) : (
                `ExternalReviewForm.errorDesc-${error}`
            )
        }
        rootClassName={css.alert}
        closeAllowed={false}
    />
);
